<template>
    <div >

            <h3 style="color: #426590;margin-bottom:15px;">CROSS REFERENCE</h3>
            <div style="margin-left: auto;width: fit-content;font-weight: 600">Instructions</div>
            <div style="width:100%;background-color: #F0F9FF">
                <div class="row" style="padding: 10px 0px">
                    <div class="col-10 col-md-7 col-lg-5 offset-0 offset-md-2 offset-lg-3">
                        <div style="padding-top: 10px;height: 38px;">
                            <div style="float: left;">
                                <p style="text-align: right;width: 120px;">Job Name:</p>
                            </div>
                            <div style="width: calc(100% - 130px);float: right"><input type="text" class="input-natural"></div>
                        </div>
                        <div style="padding-top: 10px;">
                            <div style="float: left;text-align: right;width: 120px;">
                                <p style="text-align: right">Email Report to:</p>
                            </div>
                            <div style="width: calc(100% - 130px);float: right"><input type="text" class="input-natural"></div>
                        </div>
                    </div>
                    <div class="col-2 col-md-1" style="padding: 25px 0px;">
                        <button class="btn btn-primary" style="font-size: 12px;padding: 2px 10px;">
                            Send Email
                        </button>
                    </div>
                </div>
            </div>
            <div class="row" style="padding-top: 30px">
                <div class="col-12 col-md-6 col-lg-4">
                    <label style="font-weight: 400;color:#000;font-size: 13px">Select Manufacturer</label>
                    <select style="width: 100%;">
                        <option>--Select Manufacturer--</option>
                    </select>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <label style="font-weight: 400;color:#000;font-size: 13px">Select Product</label>
                    <select style="width: 100%;">
                        <option>--Select Manufacturer--</option>
                        <option v-for="product in this.products" :value="product.id">{{product.title}}</option>
                    </select>
                </div>
                <div class="col-2">
                    <button class="btn btn-primary add-button" @click="load()">ADD</button>
                </div>
                <div class="col-12">
                    <table width="100%">
                        <tr>
                            <th style="background-color: #2967AD;color:#fff;padding: 8px 15px;">Brand</th>
                            <th style="background-color: #2967AD;color:#fff;">Product</th>
                            <th style="background-color: #2967AD;color:#fff;">POTTORFF</th>
                            <th style="background-color: #2967AD;color:#fff;">Description</th>
                            <th style="text-align: right;background-color: #2967AD;color:#fff;padding-right: 25px">Required Attributes</th>
                        </tr>
                    </table>
                </div>
                <div class="col-12 mt-5">
                    <label style="font-weight: 400;color:#000;font-size: 13px">Print Pottorff Cross Reference Table by Product Group</label>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <select style="width: 100%;">
                        <option>--Select Manufacturer--</option>
                    </select>
                    <button class="btn btn-primary" style="padding: 2px 10px;">Download</button>
                </div>
                <div class="col-12" style="font-weight: 400;color:#000;font-size: 13px">Pottorff´s cross reference program is for a general reference only. Please click on the Pottorff product link and review specifications to make sure it is correct for your project needs.</div>
            </div>
    </div>
</template>
<script>
export default {
    props: [],
    name: 'cross-reference-show-page',
    data () {
        return {
            products: {}
        };
    },
    methods: {
        async load () {
            const  products  = await axios.get('/api/crossproducts/1');

            this.products = products.data;
        }
    },
    watch: {
        selectedSubCategory () {
            if (this.loaded) {
                this.load();
            }
        },
    },
    async mounted () {
        await this.load();
    }
};
</script>

